import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <BreadCrumbs
  @categories={{this.categories}}
  @category={{this.category}}
  @noSubcategories={{this.noSubcategories}}
  @tag={{this.tag}}
  @additionalTags={{this.additionalTags}}
/>

{{#unless this.additionalTags}}
  {{! nav bar doesn't work with tag intersections }}
  <NavigationBar
    @navItems={{this.navItems}}
    @filterMode={{this.filterMode}}
    @category={{this.category}}
    @tag={{this.tag}}
  />
{{/unless}}

<div class="navigation-controls">
  {{#if (and this.notCategoriesRoute this.site.mobileView @canBulkSelect)}}
    <BulkSelectToggle @bulkSelectHelper={{@bulkSelectHelper}} />
  {{/if}}

  <TopicDismissButtons
    @position="top"
    @selectedTopics={{@bulkSelectHelper.selected}}
    @model={{@model}}
    @showResetNew={{@showResetNew}}
    @showDismissRead={{@showDismissRead}}
    @resetNew={{@resetNew}}
    @dismissRead={{@dismissRead}}
  />

  {{#if this.showCategoryAdmin}}
    {{#if this.fixedCategoryPositions}}
      <CategoriesAdminDropdown
        @onChange={{action "selectCategoryAdminDropdownAction"}}
        @options={{hash triggerOnChangeOnTab=false}}
      />
    {{else}}
      <DButton
        @action={{this.createCategory}}
        @icon="plus"
        @label={{if
          this.site.mobileView
          "categories.category"
          "category.create"
        }}
        class="btn-default"
        id="create-category"
      />
    {{/if}}
  {{/if}}

  {{#if (and this.category this.showCategoryEdit)}}
    <DButton
      @action={{this.editCategory}}
      @icon="wrench"
      @title="category.edit_title"
      class="btn-default edit-category"
    />
  {{/if}}

  {{#if this.tag}}
    {{#if this.showToggleInfo}}
      <DButton
        @icon={{if this.currentUser.staff "wrench" "info-circle"}}
        @ariaLabel="tagging.info"
        @action={{this.toggleInfo}}
        id="show-tag-info"
        class="btn-default"
      />
    {{/if}}
  {{/if}}

  <PluginOutlet
    @name="before-create-topic-button"
    @outletArgs={{hash
      canCreateTopic=this.canCreateTopic
      createTopicDisabled=this.createTopicDisabled
      createTopicLabel=this.createTopicLabel
      additionalTags=this.additionalTags
      category=this.category
      tag=this.tag
    }}
  />

  <CreateTopicButton
    @canCreateTopic={{this.canCreateTopic}}
    @action={{action "clickCreateTopicButton"}}
    @disabled={{this.createTopicButtonDisabled}}
    @label={{this.createTopicLabel}}
    @btnClass={{this.createTopicClass}}
    @canCreateTopicOnTag={{this.canCreateTopicOnTag}}
  />

  <PluginOutlet
    @name="after-create-topic-button"
    @outletArgs={{hash
      canCreateTopic=this.canCreateTopic
      createTopicDisabled=this.createTopicDisabled
      createTopicLabel=this.createTopicLabel
      category=this.category
      tag=this.tag
    }}
  />

  {{#if this.category}}
    {{#unless this.tag}}
      {{! don't show category notification menu on tag pages }}
      {{#if this.showCategoryNotifications}}
        <CategoryNotificationsButton
          @value={{this.categoryNotificationLevel}}
          @category={{this.category}}
          @onChange={{action "changeCategoryNotificationLevel"}}
        />
      {{/if}}
    {{/unless}}
  {{/if}}

  {{#if this.tag}}
    {{#unless this.category}}
      {{! don't show tag notification menu on category pages }}
      {{#if this.showTagNotifications}}
        <TagNotificationsButton
          @onChange={{this.changeTagNotificationLevel}}
          @value={{this.tagNotification.notification_level}}
        />
      {{/if}}
    {{/unless}}
  {{/if}}
</div>
*/
{
  "id": "2fXjcLcC",
  "block": "[[[8,[39,0],null,[[\"@categories\",\"@category\",\"@noSubcategories\",\"@tag\",\"@additionalTags\"],[[30,0,[\"categories\"]],[30,0,[\"category\"]],[30,0,[\"noSubcategories\"]],[30,0,[\"tag\"]],[30,0,[\"additionalTags\"]]]],null],[1,\"\\n\\n\"],[41,[51,[30,0,[\"additionalTags\"]]],[[[1,\"  \"],[8,[39,2],null,[[\"@navItems\",\"@filterMode\",\"@category\",\"@tag\"],[[30,0,[\"navItems\"]],[30,0,[\"filterMode\"]],[30,0,[\"category\"]],[30,0,[\"tag\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,0],[14,0,\"navigation-controls\"],[12],[1,\"\\n\"],[41,[28,[37,4],[[30,0,[\"notCategoriesRoute\"]],[30,0,[\"site\",\"mobileView\"]],[30,1]],null],[[[1,\"    \"],[8,[39,5],null,[[\"@bulkSelectHelper\"],[[30,2]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[8,[39,6],null,[[\"@position\",\"@selectedTopics\",\"@model\",\"@showResetNew\",\"@showDismissRead\",\"@resetNew\",\"@dismissRead\"],[\"top\",[30,2,[\"selected\"]],[30,3],[30,4],[30,5],[30,6],[30,7]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"showCategoryAdmin\"]],[[[41,[30,0,[\"fixedCategoryPositions\"]],[[[1,\"      \"],[8,[39,7],null,[[\"@onChange\",\"@options\"],[[28,[37,8],[[30,0],\"selectCategoryAdminDropdownAction\"],null],[28,[37,9],null,[[\"triggerOnChangeOnTab\"],[false]]]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,10],[[24,0,\"btn-default\"],[24,1,\"create-category\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"createCategory\"]],\"plus\",[52,[30,0,[\"site\",\"mobileView\"]],\"categories.category\",\"category.create\"]]],null],[1,\"\\n\"]],[]]]],[]],null],[1,\"\\n\"],[41,[28,[37,4],[[30,0,[\"category\"]],[30,0,[\"showCategoryEdit\"]]],null],[[[1,\"    \"],[8,[39,10],[[24,0,\"btn-default edit-category\"]],[[\"@action\",\"@icon\",\"@title\"],[[30,0,[\"editCategory\"]],\"wrench\",\"category.edit_title\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"tag\"]],[[[41,[30,0,[\"showToggleInfo\"]],[[[1,\"      \"],[8,[39,10],[[24,1,\"show-tag-info\"],[24,0,\"btn-default\"]],[[\"@icon\",\"@ariaLabel\",\"@action\"],[[52,[30,0,[\"currentUser\",\"staff\"]],\"wrench\",\"info-circle\"],\"tagging.info\",[30,0,[\"toggleInfo\"]]]],null],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n  \"],[8,[39,11],null,[[\"@name\",\"@outletArgs\"],[\"before-create-topic-button\",[28,[37,9],null,[[\"canCreateTopic\",\"createTopicDisabled\",\"createTopicLabel\",\"additionalTags\",\"category\",\"tag\"],[[30,0,[\"canCreateTopic\"]],[30,0,[\"createTopicDisabled\"]],[30,0,[\"createTopicLabel\"]],[30,0,[\"additionalTags\"]],[30,0,[\"category\"]],[30,0,[\"tag\"]]]]]]],null],[1,\"\\n\\n  \"],[8,[39,12],null,[[\"@canCreateTopic\",\"@action\",\"@disabled\",\"@label\",\"@btnClass\",\"@canCreateTopicOnTag\"],[[30,0,[\"canCreateTopic\"]],[28,[37,8],[[30,0],\"clickCreateTopicButton\"],null],[30,0,[\"createTopicButtonDisabled\"]],[30,0,[\"createTopicLabel\"]],[30,0,[\"createTopicClass\"]],[30,0,[\"canCreateTopicOnTag\"]]]],null],[1,\"\\n\\n  \"],[8,[39,11],null,[[\"@name\",\"@outletArgs\"],[\"after-create-topic-button\",[28,[37,9],null,[[\"canCreateTopic\",\"createTopicDisabled\",\"createTopicLabel\",\"category\",\"tag\"],[[30,0,[\"canCreateTopic\"]],[30,0,[\"createTopicDisabled\"]],[30,0,[\"createTopicLabel\"]],[30,0,[\"category\"]],[30,0,[\"tag\"]]]]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"category\"]],[[[41,[51,[30,0,[\"tag\"]]],[[[41,[30,0,[\"showCategoryNotifications\"]],[[[1,\"        \"],[8,[39,13],null,[[\"@value\",\"@category\",\"@onChange\"],[[30,0,[\"categoryNotificationLevel\"]],[30,0,[\"category\"]],[28,[37,8],[[30,0],\"changeCategoryNotificationLevel\"],null]]],null],[1,\"\\n\"]],[]],null]],[]],null]],[]],null],[1,\"\\n\"],[41,[30,0,[\"tag\"]],[[[41,[51,[30,0,[\"category\"]]],[[[41,[30,0,[\"showTagNotifications\"]],[[[1,\"        \"],[8,[39,14],null,[[\"@onChange\",\"@value\"],[[30,0,[\"changeTagNotificationLevel\"]],[30,0,[\"tagNotification\",\"notification_level\"]]]],null],[1,\"\\n\"]],[]],null]],[]],null]],[]],null],[13]],[\"@canBulkSelect\",\"@bulkSelectHelper\",\"@model\",\"@showResetNew\",\"@showDismissRead\",\"@resetNew\",\"@dismissRead\"],false,[\"bread-crumbs\",\"unless\",\"navigation-bar\",\"if\",\"and\",\"bulk-select-toggle\",\"topic-dismiss-buttons\",\"categories-admin-dropdown\",\"action\",\"hash\",\"d-button\",\"plugin-outlet\",\"create-topic-button\",\"category-notifications-button\",\"tag-notifications-button\"]]",
  "moduleName": "discourse/components/d-navigation.hbs",
  "isStrictMode": false
});